<template>
  <div class="px-2 py-2 d-flex align-items-center">
    <div class="ml-3 d-flex flex-column">
      <small> <span class="text-info">ชื่อ</span> {{ name }}</small>
      <small>
        <span class="text-info">หน่วยงาน</span>
        {{ department ? department : "" }}</small
      >
    </div>
  </div>
</template>

<script>
import noImage from "../assets/image/mock/no-image.png";
export default {
  data() {
    return {
      noImage: noImage,
    };
  },
  props: ["name", "image", "id", "department"],
};
</script>

<style>
.img-panel {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.parent {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
}
</style>
